import { Injectable } from "@angular/core";

import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";

import { SafetyPointModelView } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class SafetyPointViewService extends RestReadServiceBase<SafetyPointModelView> {
    constructor(
    ) {
        super("SafetyPointModelView", false);
    }
    public search(keyword: string): Promise<SafetyPointModelView[]> {
        return this.getHttpRequest(this.baseUri + '/safetypoint-list/search?keyword=' + keyword);
    }
}